export const KafkaAudioData = {
    global: {
        tempo: 62,
        signature: [6, 8],
    },
    voiceover: {
        id: "kafka-voiceover",
    },
    gesture: {
        samples: [
            { name: 'piano-3' },
            { name: 'piano-4' },
            { name: 'piano-5' },
            { name: 'piano-6' },
            { name: 'piano-7' },
        ],
        shuffle: true,
        volume: 0,
    },
    background: {
        samplePool: ['trashcan-ghost-bed'],
        volume: -128,
        fadeInDuration: 2,
        fadeOutDuration: 2,
        loopStart: 0,
        loopEnd: 34000,
    },
    sharedLoops: [
        {
            name: "kalimba",
            samplePool: ['kalimba-long', 'kalimba-short', 'kalimba-minimal'],
            length: "8m",
            volume: -12,
        },
        {
            name: "musicbox",
            samplePool: ['musicbox-long-1', 'musicbox-long-2', 'musicbox-short-1'],
            length: "8m",
            volume: -12,
        },
        {
            name: "guitar",
            samplePool: ['guitar-loop', 'guitar-long'],
            length: "8m",
            volume: -6,
        },
        {
            name: "celeste",
            samplePool: ['celeste'],
            length: "4m",
            volume: -9,
        },
    ],
    scenes: [
        // 0: TITLES
        {
            name: "Titles",
            background: {
                samplePool: ['polar-wind'],
                volume: -3,
                fadeInDuration: 2,
                fadeOutDuration: 8,
                loopStart: 0,
                loopEnd: 22000,
            },
            worldBackgroundVolume: -128,
        },
        // 1. ROOM NEAR
        {
            name: "Room Near",
            tracks: [
                {
                    group: "kalimba",
                    sampleIndex: [0, 1],
                    volume: -12,
                },
                {
                    group: "musicbox",
                    sampleIndex: [0, 1],
                    volume: -12,
                },
            ],
            fadeInDuration: 2,
            worldBackgroundVolume: -9,
        },
        // 2. TABLE
        {
            name: "Table",
            tracks: [
                {
                    group: "kalimba",
                    sampleIndex: [1, 2],
                },
                {
                    group: "musicbox",
                    sampleIndex: [2],
                    length: "4m" // Mmm - not sure this will work... TODO: make it work
                },
                {
                    group: "guitar",
                    randomOrder: true,
                    followAction: "chain",
                    sampleIndex: [0, 1],
                    length: "12m"
                },
            ],
            worldBackgroundVolume: -9,
        },
        // 3. HOUSEKEEPER
        {
            name: "Housekeeper",
            tracks: [
                {
                    group: "kalimba",
                    randomOrder: true,
                    followAction: "chain",
                    length: "4m"
                },
                {
                    group: "celeste",
                },
                {
                    volume: -24,
                    followAction: "chain",
                    samplePool: [
                        'guitar-2',
                        'guitar-4',
                        'guitar-6',
                    ],
                    length: "4m"
                },
            ],
            worldBackgroundVolume: -9,
        },
        // 4. SIAMESE
        {
            name: "Siamese",
            effects: {
                volume: 0,
                effectPool: [
                    {
                        src: 'whispers-1',
                        delay: 3,
                    }
                ],
            },
            tracks: [
                {
                    group: "kalimba",
                    length: "4m"
                },
                {
                    randomOrder: true,
                    followAction: "chain",
                    samplePool: [
                        'carousel-organ-1',
                        'carousel-organ-2',
                        'carousel-organ-3',
                        'carousel-organ-4'
                    ],
                    length: "4m"
                },
            ],
            worldBackgroundVolume: -9,
        },
        // 5. ROOM_FAR
        {
            name: "Room Far",
            tracks: [
                {
                    group: "kalimba",
                    sampleIndex: [1, 2],
                    length: "4m" // can we do this? change the length?
                },
                {
                    group: "musicbox",
                    sampleIndex: [0, 1],
                },
                {
                    group: "celeste",
                },
                {
                    randomOrder: true,
                    followAction: "chain",
                    samplePool: [
                        'guitar-loop',
                        'guitar-long',
                        'guitar-3',
                        'guitar-5',
                    ],
                    length: "4m"
                },
            ],
            worldBackgroundVolume: -9,
        },
        // 6. WALL
        {
            name: "Wall",
            effects: {
                volume: -3,
                random: true,
                effectPool: [
                    {
                        src: 'dogs-1',
                        volume: -3,
                        delay: 2,
                    },
                    {
                        src: 'dogs-2',
                        volume: -12,
                        delay: 2,
                    },
                ],
            },
            worldBackgroundVolume: -9,
        },
        // 7. AERIAL_VIEW
        {
            name: "Aerial View",
            effects: {
                random: true,
                followAction: "chain",
                volume: -12,
                effectPool: [
                    {
                        src: 'jules-singing-1',
                        delay: 2,
                    },
                    {
                        src: 'jules-singing-2',
                        delay: 4,
                    },
                    {
                        src: 'jules-singing-3',
                        delay: 2,
                    },
                    {
                        src: 'jules-singing-4',
                        delay: 3,
                    },
                    {
                        src: 'jules-singing-5',
                        delay: 5,
                    },
                    {
                        src: 'jules-singing-6',
                        delay: 2,
                    },
                    {
                        src: 'jules-whistling-1',
                        delay: 3,
                    },
                    {
                        src: 'jules-whistling-2',
                        delay: 4,
                    },
                ]
            },
            worldBackgroundVolume: -9,
        },
        // 8. NEIGHBOUR
        {
            name: "Neighbour",
            effects: {
                random: true,
                followAction: "chain",
                volume: -9,
                effectPool: [
                    {
                        src: 'soprano-1',
                        delay: 3,
                    },
                    {
                        src: 'soprano-2',
                        delay: 2,
                    },
                    {
                        src: 'soprano-3',
                        delay: 3,
                    },
                    {
                        src: 'soprano-4',
                        delay: 3,
                    },
                ],
            },
            worldBackgroundVolume: -9,
        },
    ]
};
